import GenericListTab from "../../factories/generic-list-tab";
import TabPage from "../../factories/tab-page";
import * as ko from "knockout";
import guid from "../../factories/guid";
import { BaseModel2 } from "../../interfaces/base-model2";
import { SelectMultipleValue } from "../../components/select-multiple/select-multiple-models";



/**
 * interface for the LabelConfigurationItemModel
 */
interface LabelConfigurationItem extends BaseModel2 {
    LabelId: string,
    ConfigurationItemId: string,
    LabelConfigurationItemId: string,
    LabelName: string | KnockoutObservable<string>
}
// "this" doesent work in OnNewItem / OnDeletedItem because they are called from the select-multiple-module component
let self: ConfigurationItemLabelTabViewModel = null;

/**
 * ViewModel for the ConfigurationItemLabelTab
 */
class ConfigurationItemLabelTabViewModel extends GenericListTab {

    /**
     * The ConfigurationItem
     */
    Parent: any;
    /**
     the Url of the Controller for this ViewModel
     */
    ControllerUrl: string = "ConfigurationItemLabelTab";

    Labels: KnockoutObservableArray<LabelConfigurationItem>; 

    /**
     * @param tabPage The TabPage
     * @param parent The ConfigurationItem
     */
    constructor(public tabPage: TabPage, parent: any) {
        super(tabPage, parent);
        this.Parent = parent;
        self = this;
    }

    init() {
        return super.init().then(() => {
            this.Labels = ko.observableArray(<any> [...this.Models()]);
        })
    }
    

    /**
     * Returns the URL to Init the Models 
     * @returns the Url to Init the Models
     */
    InitUrl(): string {
        return this.ControllerUrl + "/Init";
    }

    /**
     * Defines if the Model is Complete 
     * @returns true because there are no MandatoryFields 
     */
    CompleteCheck(): boolean | JQueryPromise<boolean> {
        return true;
    }

    /**
     * CustomFilter to Filter Models
     * @returns null because no Filter is needed
     */
    CustomFilter(): Models.HashObject[] {
        return null;
    }

    /**
     *  Checks if a Item is Complete 
     * @param item the given item
     * @returns A Promisse that always returns true 
     */
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred(() => true);
    }

    protected OnNewItem(newItem: SelectMultipleValue) {
        let id = guid();
        let model:LabelConfigurationItem = {
            ConfigurationItemId: self.Parent.ConfigurationItemId(),
            PrimaryKeyValue: id,
            LabelConfigurationItemId: id,
            LabelName: ko.unwrap(newItem.LabelName),
            PrimaryKeyName: "LabelConfigurationItemId",
            LabelId: null
        } 
        let models = self.Models();
        models.push(model);
        self.Models(models);
        self.Save(model);
        self.TabPage.DirtyFlag(true);
    }

    protected OnDeletedItem(deletedItem: LabelConfigurationItem) {
        
        let removedModel = self.GetModelByLabel(ko.unwrap(deletedItem.LabelName))

        self.Remove([removedModel.PrimaryKeyValue]);
        self.TabPage.DirtyFlag(true);
    }

    protected GetModelByLabel(label: string) {
        return self.Models().find((m:any) => m.LabelName === label);
    }
}

export default ConfigurationItemLabelTabViewModel;